import { Box, Container, Grid } from "@mui/material";
import { useState } from "react";
import CountriesForImmersion from "src/json/Immersionjson/CountriesForImmersion";
import Header from "../content-component/Header";

const FlipCard = ({ country }) => {
  // eslint-disable-next-line no-unused-vars
  const [isFlipped, setIsFlipped] = useState(false);

  return (
    <Box
      sx={{
        width: "220px",
        height: "260px",
        perspective: "1200px",
        cursor: "pointer",
      }}
      onClick={() => window.location.href = country.path}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          transformStyle: "preserve-3d",
          transition: "transform 0.6s ease-in-out",
          transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)",
          position: "relative",
        }}
        // onMouseEnter={() => setIsFlipped(true)}                                       // Required Later
        // onMouseLeave={() => setIsFlipped(false)}
      >
        {/* Front Side */}
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backfaceVisibility: "hidden",
            backgroundColor: "#0a9da2",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "12px",
            color: "white",
            fontSize: "32px",
            fontWeight: "bold",
            textAlign: "center",
            boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
            padding: "10px",
          }}
        >
          {country.title}
        </Box>

        {/* Back Side */}
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backfaceVisibility: "hidden",
            backgroundColor: "#087a7e",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "10px",
            color: "white",
            fontSize: "20px",
            textAlign: "center",
            boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
            padding: "10px",
            transform: "rotateY(180deg)",
          }}
        >
          <ul style={{ textAlign: "left", padding: "10px", margin: 0,}}>
            {country?.items?.map((item, index) => (
              <li key={index} style={{ fontSize: "14px", lineHeight: "1.5",marginLeft:'5px' }}>
                {item}
              </li>
            ))}
          </ul>
        </Box>
      </Box>
    </Box>
  );
};

const CountriesServeDestination = () => {
  return (
    <Box sx={{ backgroundColor: "#F1FEFF", p: "50px 0" }}>
      <Container maxWidth="lg">
      <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 5,
          }}
        >
          <Header content={"Zone We Serve"} textAlign={"center"} />
        </Box>
        <Grid container spacing={3} justifyContent="center">
          {CountriesForImmersion?.map((country, index) => (
            <Grid item xs={12} sm={6} md={3} key={index} display="flex" justifyContent="center">
              <FlipCard country={country} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CountriesServeDestination;
